<template lang="pug">
a(:href="href" :target="props.target" data-allow-mismatch="attribute")
  slot
</template>
<script setup lang="ts">
import { computed } from 'vue'
import { type LocationQuery, useRouter } from 'vue-router'
import { useRogue } from '../services/Rogue'

const props = defineProps<{
  to : string | LocationQuery,
  target?: string,
}>()

const router = useRouter()
const rogue = useRogue()

const href = computed<string>(() => {
  if (props.to && typeof props.to === 'object') {
    return router.resolve(props.to).href
  }

  if (typeof props.to === 'string') {
    if (props.to.startsWith('http') || props.to.startsWith('mailto:') || props.to.startsWith('tel:')) {
      return props.to
    }

    if (props.to === '/') {
      return `${rogue.localizedBaseURL}/`
    }

    return `${rogue.l10n.path}${props.to}`
  }

  return '#'
})
</script>
